import httpMethod from 'services/update2025/httpMethod';
import BlockDetail from "components/block-detail/BlockDetail";
import { Button } from "primereact/button";
import { InputMask } from "primereact/inputmask";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { findDependentHistoryList, findDependentList } from "services/dependentHistoryService";
import { X_TOTAL_COUNT } from "utils/constants";
import { handleError } from "utils/handleError";
import { DependentHistoryContext } from "./DependentHistoryContext";
import "./scss/DependentHistory.scss";
import { DependentHistoryDependences } from "./DependentHistoryDependences";
import { findInfoCard } from "services/PersonInfoService";
import { DependentHistoryInfo } from "./DependentHistoryInfo";
import { dateFormat1, dateFormat2 } from "utils/date";
import { Calendar } from "primereact/calendar";

export const DependentHistoryList = () => {
    const avatar = process.env.PUBLIC_URL + "/assets/layout/images/avatar.png";
    const toast = useRef(null);
    const dt = useRef(null);
    const { t, i18n } = useTranslation(["dependent-history", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const dependentHistoryContext = useContext(DependentHistoryContext);
    const { dependents, setDependents, dependent, setDependent, setDependentHistories, dependentHistoryDialog, setDependentHistoryDialog, dependentHistoryInfoDialog, setDependentHistoryInfoDialog } = dependentHistoryContext;

    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [checkLoad, setCheckLoad] = useState(false);

    const [selectedDependent, setSelectedDependent] = useState(null);

    const [formatDateVal, setFormatDateVal] = useState(dateFormat1);

    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 10,
        page: 0,
        filters: {
            idNumber: { value: "", matchMode: "contains" },
            fullName: { value: "", matchMode: "contains" },
            birthDate: { value: null, matchMode: "equals" },
            idNumberDependent: { value: null, matchMode: "contains" },
        },
    });

    useEffect(() => {
        if (checkLoad) {
            loadLazyData();
            setCheckLoad(false);
        }
    }, [lazyParams]);

    useEffect(() => {
        if (selectedDependent && selectedDependent.id) {
            findDependentHistoryList(headers, selectedDependent.id)
                .then((res) => {
                    const dataRes = res.data;
                    dataRes?.forEach((e, i) => {
                        if (e.contentChanges) {
                            e.contents = Object.entries(JSON.parse(e.contentChanges)).map((x, y) => {
                                const values = x[1]?.split("->");
                                return { stt: y + 1, field: x[0], valueBefore: values[0], valueAfter: values[1] };
                            });
                        } else {
                            e.contents = [];
                        }
                    });
                    dataRes.forEach((e, i) => {
                        e.stt = i + 1;
                    });
                    setDependentHistories(dataRes);
                })
                .catch((error) => handleError(toast, t, error))
                .finally(() => setLoading(false));

            findInfoCard(headers, selectedDependent.idNumber).then((res) => {
                const dataRes = res.data;
                setDependent(dataRes);
            });
        } else {
            setDependentHistories([]);
        }
    }, [selectedDependent]);

    const loadLazyData = () => {
        setLoading(true);
        setSelectedDependent(null);
        setDependent(null);
        setDependentHistories([]);
        findDependentList(headers, lazyParams)
            .then((res) => {
                setTotalRecords(res.headers[X_TOTAL_COUNT] ? parseInt(res.headers[X_TOTAL_COUNT]) : 0);
                const dataRes = res.data;
                dataRes?.forEach((e, i) => {
                    e.stt = lazyParams.rows * lazyParams.page + 1 + i;
                });
                setDependents(dataRes);
                if (dataRes.length > 0) {
                    setSelectedDependent(dataRes[0]);
                }
            })
            .catch((error) => handleError(toast, t, error))
            .finally(() => setLoading(false));
    };

    const onPage = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onSort = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        setLazyParams(_lazyParams);
    };

    const onFilter = (event) => {
        setCheckLoad(true);
        let _lazyParams = { ...lazyParams, ...event };
        _lazyParams["first"] = 0;
        setLazyParams(_lazyParams);
    };

    const bỉrthDateTemplateBody = (rowData) => {
        return (
            <div className="flex align-items-center justify-content-center">
                <p>{rowData?.birthDate?.substr(0, 10)}</p>
            </div>
        );
    };

    const viewInfoDialog = () => {
        setDependentHistoryInfoDialog(true);
    };

    const paginatorTemplate = {
        layout: "RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink",
        RowsPerPageDropdown: (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 30, value: 30 },
                { label: 50, value: 50 },
            ];

            return (
                <React.Fragment>
                    <div style={{ width: "140px", display: "inline-block" }}>
                        <span className="mx-1">{t("show", { ns: "common" })}: </span>
                        <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                    </div>
                </React.Fragment>
            );
        },
        CurrentPageReport: (options) => {
            return <span style={{ width: "calc(100% - 490px)", textAlign: "center", display: "inline-block" }}>{t("total", { ns: "common", total: options.totalRecords })}</span>;
        },
    };

    const searchOption = (
        <div className="grid">
            {/* Số ĐDCN */}
            <div className="col-12 md:col-3">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "82px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="idNumber"
                    >
                        {t("dependent.idNumber")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="idNumber"
                            name="idNumber"
                            onChange={(e) => {
                                setCheckLoad(false);
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        idNumber: {
                                            ...lazyParams.filters.idNumber,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                    </div>
                </div>
            </div>

            {/* họ và tên */}
            <div className="col-12 md:col-3">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "80px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="fullName"
                    >
                        {t("dependent.fullName")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            id="fullName"
                            name="fullName"
                            onChange={(e) => {
                                setCheckLoad(false);
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        fullName: {
                                            ...lazyParams.filters.fullName,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                    </div>
                </div>
            </div>

            {/* ngày sinh  */}
            <div className="col-12 md:col-2">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "80px",
                            justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="birthDate"
                    >
                        {t("dependent.birthDate")}
                    </label>
                    <div className="col">
                        <Calendar
                            style={{ width: "100%" }}
                            value={lazyParams.filters.birthDate.value}
                            onChange={(e) => {
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        birthDate: {
                                            ...lazyParams.filters.birthDate,
                                            value: e.value,
                                        },
                                    },
                                });
                            }}
                            onBlur={() => {
                                setFormatDateVal(dateFormat1);
                            }}
                            onFocus={() => {
                                setFormatDateVal(dateFormat2);
                            }}
                            name="birthDate"
                            id="birthDate"
                            dateFormat={formatDateVal}
                        ></Calendar>
                        {/* <InputText
                            style={{
                                // margin: " 5px 0px 0px 5px",
                                width: "100%",
                            }}
                            d
                            id="birthDate"
                            name="birthDate"
                            type="date"
                            onChange={(e) => {
                                setCheckLoad(false);
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        birthDate: {
                                            ...lazyParams.filters.birthDate,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText> */}
                    </div>
                </div>
            </div>

            {/* số CCCD người Đk */}
            <div className="col-12 md:col-3">
                <div className="grid custom-form">
                    <label
                        className="col-fixed text-center"
                        style={{
                            width: "162px",
                            // justifyContent: "end",
                            display: "flex",
                            padding: "0.75rem 0px 0px 0px",
                        }}
                        htmlFor="idNumberDependent"
                    >
                        {t("dependent.idNumberDependent1")}
                    </label>
                    <div className="col">
                        <InputText
                            style={{
                                width: "100%",
                            }}
                            d
                            id="idNumberDependent"
                            name="idNumberDependent"
                            type="text"
                            onChange={(e) => {
                                setCheckLoad(false);
                                setLazyParams({
                                    ...lazyParams,
                                    filters: {
                                        ...lazyParams.filters,
                                        idNumberDependent: {
                                            ...lazyParams.filters.idNumberDependent,
                                            value: e.target.value,
                                        },
                                    },
                                });
                            }}
                        ></InputText>
                    </div>
                </div>
            </div>

            <div className="col-12 md:col-1 text-right">
                <div className="grid custom-form">
                    <div className="col-12">
                        <label
                            style={{
                                width: "80px",
                                // justifyContent: "end",
                                display: "flex",
                                padding: "0.75rem 0px 0px 0px",
                            }}
                        >
                            {" "}
                        </label>
                    </div>
                    <div className="col-12" style={{ margin: "5px 0px 0px 0px" }}>
                        <Button
                            label={t("search", { ns: "common" })}
                            icon="pi pi-search"
                            onClick={(e) => {
                                if (lazyParams.filters.idNumber.value || (lazyParams.filters.fullName.value && lazyParams.filters.birthDate.value) || lazyParams.filters.idNumberDependent) {
                                    setCheckLoad(true);
                                    setLazyParams({
                                        ...lazyParams,
                                        first: 0,
                                        page: 0,
                                    });
                                } else {
                                    toast.current.show({
                                        severity: "info",
                                        summary: t("info", { ns: "common" }),
                                        detail: t("dependent.validate"),
                                        life: 3000,
                                    });
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <div className="grid crud">
            <div className="col-12">
                <div className="card">
                    <div className="grid">
                        <div className="col-12">
                            <h4 className="text-center font-bold">{t("dependent.title")?.toUpperCase()}</h4>
                        </div>
                    </div>
                    <div className="grid">
                        <div className="col-12">
                            <BlockDetail title={t("search", { ns: "common" })}>{searchOption}</BlockDetail>
                        </div>
                    </div>

                    <div className="grid mt-3">
                        <div className="col-12">
                            <BlockDetail title={t("dependent.list")}>
                                <Toast ref={toast} />
                                <DataTable
                                    ref={dt}
                                    value={dependents}
                                    dataKey="stt"
                                    className="datatable-responsive p-datatable-sm"
                                    selectionMode="single"
                                    selection={selectedDependent}
                                    onSelectionChange={(e) => {
                                        setSelectedDependent(e.value);
                                    }}
                                    showGridlines
                                    lazy
                                    paginator
                                    rows={lazyParams.rows}
                                    first={lazyParams.first}
                                    totalRecords={totalRecords}
                                    onPage={onPage}
                                    onSort={onSort}
                                    sortField={lazyParams.sortField}
                                    sortOrder={lazyParams.sortOrder}
                                    onFilter={onFilter}
                                    filters={lazyParams.filters}
                                    loading={loading}
                                    paginatorClassName="justify-content-start"
                                    paginatorTemplate={paginatorTemplate}
                                    emptyMessage="Không có dữ liệu"
                                    scrollable
                                >
                                    <Column field="stt" header={t("stt", { ns: "common" })} style={{ maxWidth: "50px" }} />
                                    <Column field="idNumber" header={t("dependent.idNumber")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="fullName" header={t("dependent.fullName")} style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="birthDate" header={t("dependent.birthDate")} body={bỉrthDateTemplateBody} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="gender" header={t("dependent.gender")} style={{ maxWidth: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }}></Column>
                                    <Column field="birthPlace" header={t("dependent.birthPlace")} style={{ minWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                    <Column field="idNumberRegis" header={t("dependent.idNumberRegis")} style={{ minWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "normal" }} />
                                </DataTable>

                                {selectedDependent && (
                                    <div className="formgrid mt-3">
                                        <div className="grid">
                                            <div className="col-12">
                                                <div className="grid">
                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="relation" className="custom-form">
                                                            {t("dependent.relation")}
                                                        </label>
                                                        <InputText id="relation" value={selectedDependent?.relation} readOnly className="custom-form" />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="bloodGroup" className="custom-form">
                                                            {t("dependent.bloodGroup")}
                                                        </label>
                                                        <InputText id="bloodGroup" value={selectedDependent?.bloodGroup} readOnly className="custom-form" />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label className="custom-form" htmlFor="ethnic">
                                                            {t("dependent.ethnic")}
                                                        </label>
                                                        <InputText id="ethnic" value={selectedDependent?.ethnic} readOnly className="custom-form" />
                                                    </div>
                                                </div>

                                                <div className="grid">
                                                    <div className="field col-12 md:col-4">
                                                        <label className="custom-form" htmlFor="religion">
                                                            {t("dependent.religion")}
                                                        </label>
                                                        <InputText className="custom-form" id="religion" value={selectedDependent?.religion} readOnly />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label className="custom-form" htmlFor="nationality">
                                                            {t("dependent.nationality")}
                                                        </label>
                                                        <InputText className="custom-form" tooltip={selectedDependent?.nationality} id="nationality" value={selectedDependent?.nationality} readOnly tooltipOptions={{ position: "top" }} />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label className="custom-form" htmlFor="homeTown">
                                                            {t("dependent.homeTown")}
                                                        </label>
                                                        <InputText className="custom-form" tooltip={selectedDependent?.homeTown} id="homeTown" value={selectedDependent?.homeTown} readOnly tooltipOptions={{ position: "top" }} />
                                                    </div>
                                                </div>

                                                <div className="grid">
                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="address" className="custom-form">
                                                            {t("dependent.address")}
                                                        </label>
                                                        <InputText id="address" tooltip={selectedDependent?.address} value={selectedDependent?.address} readOnly className="custom-form" tooltipOptions={{ position: "top" }} />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="temporaryAddress" className="custom-form">
                                                            {t("dependent.temporaryAddress")}
                                                        </label>
                                                        <InputText id="temporaryAddress" tooltip={selectedDependent?.temporaryAddress} value={selectedDependent?.temporaryAddress} readOnly className="custom-form" tooltipOptions={{ position: "top" }} />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label className="custom-form" htmlFor="curAddress">
                                                            {t("dependent.curAddress")}
                                                        </label>
                                                        <InputText id="curAddress" value={selectedDependent?.curAddress} tooltip={selectedDependent?.curAddress} readOnly className="custom-form" tooltipOptions={{ position: "top" }} />
                                                    </div>
                                                </div>

                                                <div className="grid">
                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="fatherName" className="custom-form">
                                                            {t("dependent.fatherName")}
                                                        </label>
                                                        <InputText id="fatherName" value={selectedDependent?.fatherName} readOnly className="custom-form" />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="fatherNationality" className="custom-form">
                                                            {t("dependent.fatherNationality")}
                                                        </label>
                                                        <InputText id="fatherNationality" value={selectedDependent?.fatherNationality} readOnly className="custom-form" />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="fatherIdNumber" className="custom-form">
                                                            {t("dependent.fatherIdNumber")}
                                                        </label>
                                                        <InputText id="fatherIdNumber" value={selectedDependent?.fatherIdNumber} readOnly className="custom-form" />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="motherName" className="custom-form">
                                                            {t("dependent.motherName")}
                                                        </label>
                                                        <InputText id="motherName" value={selectedDependent?.motherName} readOnly className="custom-form" />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label htmlFor="motherNationality" className="custom-form">
                                                            {t("dependent.motherNationality")}
                                                        </label>
                                                        <InputText id="motherNationality" value={selectedDependent?.motherNationality} readOnly className="custom-form" />
                                                    </div>

                                                    <div className="field col-12 md:col-4">
                                                        <label className="custom-form" htmlFor="motherIdNumber">
                                                            {t("dependent.motherIdNumber")}
                                                        </label>
                                                        <InputText id="motherIdNumber" value={selectedDependent?.motherIdNumber} readOnly className="custom-form" />
                                                    </div>
                                                </div>

                                                <div className="grid">
                                                    <div className="field col-12 md:col-2">
                                                        <label htmlFor="representName" className="custom-form">
                                                            {t("dependent.representName")}
                                                        </label>
                                                        <InputText id="representName" value={selectedDependent?.representName} readOnly className="custom-form" />
                                                    </div>

                                                    <div className="field col-12 md:col-3">
                                                        <label htmlFor="representNationality" className="custom-form">
                                                            {t("dependent.representNationality")}
                                                        </label>
                                                        <InputText id="representNationality" tooltip={selectedDependent?.representNationality} value={selectedDependent?.representNationality} readOnly className="custom-form" />
                                                    </div>

                                                    <div className="field col-12 md:col-3">
                                                        <label className="custom-form" htmlFor="representIdNumber">
                                                            {t("dependent.representIdNumber")}
                                                        </label>
                                                        <InputText id="representIdNumber" value={selectedDependent?.representIdNumber} readOnly className="custom-form" />
                                                    </div>

                                                    <div
                                                        className="field col-12 md:col-4"
                                                        style={{
                                                            margin: "auto",
                                                            display: "flex",
                                                            "justify-content": "center",
                                                        }}
                                                    >
                                                        {dependent && (
                                                            <Button
                                                                style={{ height: "40px", margin: "2px" }}
                                                                label={t("dependent.person")}
                                                                onClick={(e) => {
                                                                    viewInfoDialog();
                                                                }}
                                                            />
                                                        )}
                                                        <Button
                                                            style={{ height: "40px", margin: "2px" }}
                                                            label={t("dependent.history")}
                                                            onClick={(e) => {
                                                                setDependentHistoryDialog(true);
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </BlockDetail>

                            <DependentHistoryDependences />
                            <DependentHistoryInfo />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
